// src/stores/theme.js
import { defineStore } from "pinia";

// Import images statically
import navyBg from "@/assets/landing-page/landing-background-v2.png";
import navyLoginBg from "@/assets/site-wide/captainlogo-1.png";
import navyHeaderBg from "@/assets/site-wide/protoge-header.png";
import navyCoach from "@/assets/site-wide/coach_icon.png";
import civilBg from "@/assets/landing-page/student-landing-background.png";
import civilLoginBg from "@/assets/site-wide/student-login.png";
// import civilHeaderBg from "@/assets/site-wide/student-protoge-header.png";
import civilHeaderBg from "@/assets/site-wide/student-protoge-header-cropped.png";
import civilCoach from "@/assets/site-wide/coach_icon.png";
import teamLogo from "@/assets/site-wide/umn-logo-2.png";

const THEMES = {
  navy: {
    name: "navy",
    primaryColor: "#002F6C",
    secondaryColor: "#475569",
    backgroundColor: "#C0A482",
    landingColor: "#C0A482",
    backgroundImage: navyBg,
    loginImage: navyLoginBg,
    headerImage: navyHeaderBg,
    coachImage: navyCoach,
    teamLogo: teamLogo,
  },
  civil: {
    name: "civil",
    primaryColor: "#636967ff",
    secondaryColor: "#f7f7f7ff",
    backgroundColor: "#e4e4e4ff",
    landingColor: "#e0ddccff",
    backgroundImage: civilBg,
    loginImage: civilLoginBg,
    headerImage: civilHeaderBg,
    coachImage: civilCoach,
    teamLogo: teamLogo,
  },
};

export const useThemeStore = defineStore("theme", {
  state: () => ({
    // default; will be overwritten by initFromHostname()
    current: THEMES.civil,
    // common background props
    backgroundPosition: "center top",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
  }),
  getters: {
    themeStyle(state) {
      return {
        "--primary-color": state.current.primaryColor,
        "--secondary-color": state.current.secondaryColor,
        "--background-color": state.current.backgroundColor,
        "--landing-color": state.current.landingColor,
        backgroundImage: `url(${state.current.backgroundImage})`,
        backgroundPosition: state.backgroundPosition,
        backgroundRepeat: state.backgroundRepeat,
        backgroundSize: state.backgroundSize,
        backgroundColor: state.current.backgroundColor,
      };
    },
    // handy if you want just colors
    cssVars(state) {
      return {
        "--primary-color": state.current.primaryColor,
        "--secondary-color": state.current.secondaryColor,
        "--background-color": state.current.backgroundColor,
        "--landing-color": state.current.landingColor,
      };
    },
  },
  actions: {
    initFromHostname() {
      const host = window.location.hostname;
      const isCivil =
        host === "coach.psych.umn.edu" || host.endsWith(".psych.umn.edu");
      this.current = isCivil ? THEMES.civil : THEMES.navy;
      // If you want a different sizing per theme:
      // this.backgroundSize = isCivil ? "contain" : "cover";
    },
    setTheme(name) {
      if (THEMES[name]) this.current = THEMES[name];
    },
    // Simple mapper from group to theme
    mapGroupToTheme(groupName) {
      if (!groupName) return null;
      const g = String(groupName).toLowerCase();

      if (g.startsWith("military")) return "navy";
      if (g.startsWith("civil") || g === "civilian") return "civil";

      // default fallback
      return null;
    },
    // NEW: convenience wrapper
    setThemeByGroup(groupName) {
      const mapped = this.mapGroupToTheme(groupName);
      if (mapped) this.setTheme(mapped);
    },
    // Optional: push CSS vars to :root for global use in plain CSS
    applyCssVarsToRoot() {
      const root = document.documentElement;
      const vars = this.themeStyle;
      Object.entries(vars).forEach(([k, v]) => root.style.setProperty(k, v));
    },
  },
});